// Config for gms.techempower.com

export const BASE_API_URL = '/api/v1';
export const DEVELOPMENT = true;
export const GA_MEASUREMENT_ID = 'UA-170012155-1';
export const FIREBASE_DYNAMIC_LINK_URL = 'https://gigmobile.page.link';
export const ANDROID_PACKAGE_NAME = 'com.gigxr.gigmobile';
export const APPLICATION_INSIGHTS_INSTRUMENTATION_KEY = '';
